import { Box, Chip, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { PageContext } from "../../context/PageContext";
import { ChangeTypeDict } from "../../types/data/dataTypes";
interface ChangeTypeComponentProps {
  changeTypes: ChangeTypeDict;
}

export const ChangeTypeComponent: React.FC<ChangeTypeComponentProps> = ({
  changeTypes,
}) => {
  const content = useContext(PageContext);
  const theme = useTheme();
  const relevantChanges = Object.values(changeTypes ?? {}).filter(
    (changeType) => changeType.value,
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        px: 0.5,
        py: 0.25,
        borderRadius: 1,
        mb: 0.5,
        backgroundColor: `${theme.palette.secondary.main}30`,
      }}
    >
      <Typography sx={{ fontSize: ".875rem", fontStyle: "italic" }}>
        {content.modifications}:
      </Typography>

      <Box
        sx={{
          py: 0.5,
          display: "flex",
          columnGap: 0.25,
          width: "100%",
          overflowX: "auto",
        }}
      >
        {relevantChanges?.length > 0 ? (
          relevantChanges.map((changeType) => (
            <Tooltip
              key={changeType.key}
              enterTouchDelay={0}
              title={content[`${changeType.key}_leverDescription`]}
              disableInteractive
            >
              <Chip
                label={content[`${changeType.key}_leverTitle`]}
                color="secondary"
                variant="outlined"
              />
            </Tooltip>
          ))
        ) : (
          <Typography sx={{ fontSize: ".875rem" }}>{"None"}</Typography>
        )}
      </Box>
    </Box>
  );
};
